import React from 'react';
import { Recommendation } from '../../types';
import { VisibleToolCard } from './VisibleToolCard';
import { LockedToolCard } from './LockedToolCard';

interface PartialPreviewProps {
  recommendations: Recommendation[];
}

export function PartialPreview({ recommendations }: PartialPreviewProps) {
  if (!recommendations || recommendations.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">Loading your recommendations...</p>
      </div>
    );
  }

  const visibleTool = recommendations[0];
  const totalTools = recommendations.length;
  const lockedCount = Math.max(0, totalTools - 1);

  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700">
          Your Blueprint includes {totalTools} personalized tools
        </span>
      </div>

      <div className="space-y-3">
        {visibleTool && <VisibleToolCard recommendation={visibleTool} />}

        {Array.from({ length: lockedCount }, (_, i) => (
          <LockedToolCard key={i + 2} index={i + 2} />
        ))}
      </div>

      <p className="text-center text-sm text-gray-500 mt-6 px-4">
        You're seeing a preview. Unlock to see the full Blueprint, including why each tool fits your business and which ones to avoid.
      </p>
    </div>
  );
}
